module.exports = __webpack_public_path__ + "img/20.31e4290c.png";